import React from "react";
import { IcCarrito } from "./player-components/IconosPlayer";

//botón al sitio o carrito de compras de la experiencia
const MenuOtras = ({ handleLinkButton }) => (
  <div id="menuFlotanteOtras">
    <button
      type="button"
      className="p360-btn p360-vidrio second-step"
      title="Ir a la tienda"
      aria-label="Ir a la tienda"
      onClick={() => handleLinkButton()}
    >
      <IcCarrito />
    </button>
  </div>
);
export default MenuOtras;
